import { FC } from 'react';
import Warning from '@assets/images/warning.svg';

import useStyles from './styles';

export interface ICancelIcon {}

const CancelIcon: FC<ICancelIcon> = () => {
  const css = useStyles();
  return <img src={Warning} className={css.image} />;
};

export default CancelIcon;
